import { render } from "./CreatePartInAssembly.vue?vue&type=template&id=b4fd784e&scoped=true"
import script from "./CreatePartInAssembly.vue?vue&type=script&lang=js"
export * from "./CreatePartInAssembly.vue?vue&type=script&lang=js"

import "./CreatePartInAssembly.vue?vue&type=style&index=0&id=b4fd784e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fd784e"]])

export default __exports__